import React from 'react';
import { FirebaseAuth } from 'react-firebaseui';
import { useDispatch, useSelector } from 'react-redux';
import MaterialIconButton from '@material-ui/core/IconButton';
import firebase from './firebase';
import i18next from './i18n';
import { hideLogin } from './actions';
import closeIcon from './icons/close.svg';
import 'firebaseui/dist/firebaseui.css';
import './styles/Account.css';

const uiConfig = {
  signInFlow: 'popup',
  signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID, firebase.auth.EmailAuthProvider.PROVIDER_ID],
  callbacks: {
    signInSuccessWithAuthResult: () => false,
  },
};

let customFirebaseUIModule = null;
if (i18next.language === 'zh-Hans') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__zh_cn.js');
} else if (i18next.language === 'zh-Hant') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__zh_tw.js');
} else if (i18next.language === 'fr') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__fr.js');
} else if (i18next.language === 'ja') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__ja.js');
} else if (i18next.language === 'de') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__de.js');
} else if (i18next.language === 'uk') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__uk.js');
} else if (i18next.language === 'ru') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__ru.js');
} else if (i18next.language === 'es') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__es.js');
} else if (i18next.language === 'pt') {
  customFirebaseUIModule = require('./firebaseui-langs/npm__pt_br.js');
}

// Login / register overlay for guests. On a successful sign-in, the auth
// observer in index.js dispatches setUserInfo, which clears the guest flag and
// causes this overlay (gated on !uid) to unmount.
export default function LoginOverlay() {
  const dispatch = useDispatch();
  const loginVisible = useSelector((state) => state.settings.loginVisible);
  const uid = useSelector((state) => state.user.uid);

  if (!loginVisible || uid) {
    return null;
  }

  return (
    <div className="settings account" style={{ backgroundColor: 'rgba(51,76,255, 0.7)' }}>
      <div className="card">
        <MaterialIconButton className="close-btn" onClick={() => dispatch(hideLogin())}>
          <img className="close-icon" src={closeIcon} alt="" />
        </MaterialIconButton>
        <FirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={firebase.auth()}
          customFirebaseUIModule={customFirebaseUIModule}
        />
      </div>
    </div>
  );
}
